import React, { memo } from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import dimensions from "../../globalStyles/dimensions";
import GlobalStyles from "../../globalStyles/globalStyles";
import ModalComponent from "../ModalComponent";
import ExperienceIcons from "../../assets/Icons/ExperienceIcons";

const AwaitingConfirmationModal = ({
  visible,
  toggleModal,
}: {
  visible: any;
  toggleModal: any;
}) => {
  const data = [
    // { id: 1, name: 'Food', desc: 'Food from a luxury hotel in Thailand' },
    { id: 2, name: "Drinks", desc: "Drinks from a luxury hotel in Thailand" },
  ];

  return (
    <ModalComponent isVisible={visible} toggleModal={toggleModal}>
      <View style={styles.container}>
        <View style={styles.subContainer}>
          <View style={styles.header}>
            <Text style={[GlobalStyles.heading3]}>Awaiting confirmation</Text>
            <Pressable onPress={toggleModal}>
              <ExperienceIcons.Cross />
            </Pressable>
          </View>
          <View>
            <Text style={[GlobalStyles.bodyText]}>
              Awaiting confirmation from the service provider. This usually
              takes 2 hours (max)
            </Text>
          </View>
        </View>
        <View style={[styles.okGotItView]}>
          <Text style={[GlobalStyles.bodyTextBold, styles.okGotItText]}>
            Okay, Got it
          </Text>
        </View>
      </View>
    </ModalComponent>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    // paddingHorizontal: dimensions.paddingHorizontal,
    // paddingVertical: dimensions.paddingVertical / 2,
    backgroundColor: "white",
    width: dimensions.windowWidth / 1.1,
    top: 20 * 20,
    // top:dimensions.windowHeight,
    borderRadius: 10,
    height: 179,
  },
  subContainer: {
    paddingHorizontal: dimensions.paddingHorizontal,
    paddingVertical: dimensions.paddingVertical,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: dimensions.marginVertical,
  },
  content: {
    flex: 1,
  },
  itemContainer: {
    marginBottom: dimensions.marginVertical,
  },
  itemName: {
    marginBottom: dimensions.marginVertical,
  },
  itemDesc: {
    color: "gray",
  },
  okGotItView: {
    backgroundColor: "#1F3930",
    // position:'relative',
    // bottom:0,
    width: "100%",
    height: 50,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
  okGotItText: {
    // alignSelf:'center'
    color: "#FDFBF9",
  },
});

export default memo(AwaitingConfirmationModal);
